import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  // Disable console methods in production
  console.log = () => {};
}


platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
.then(() => {
  const appRoot = document.querySelector('[ng-version]');
  appRoot?.removeAttribute('ng-version');
}).catch(err => console.error(err));
